import ApiService from '../base/BaseApiService';

// 全おしらせ取得
export const fetchAllNotices = async () => {
  try {
    return await ApiService.get('/notices/');
  } catch (error) {
    console.error('Error fetching notices:', error);
    throw error;
  }
};

// 有効なおしらせ取得
export const fetchActiveNotices = async () => {
  try {
    return await ApiService.get('/notices/active');
  } catch (error) {
    console.error('Error fetching active notices:', error);
    throw error;
  }
};

// おしらせ登録・更新
export const registerNotice = async (notice) => {
  try {
    return await ApiService.post('/notices/', notice);
  } catch (error) {
    console.error('Error registering notice:', error);
    throw error;
  }
};

// おしらせ更新
export const updateNotice = async (notice) => {
  try {
    return await ApiService.put(`/notices/${notice.id}`, notice);
  } catch (error) {
    console.error('Error updating notice:', error);
    throw error;
  }
};

// おしらせ削除
export const deleteNotice = async (id) => {
  try {
    return await ApiService.delete(`/notices/${id}`);
  } catch (error) {
    console.error('Error deleting notice:', error);
    throw error;
  }
};